import { Box, Container, Heading } from '@hover/blueprint';

import { StaticImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import { ArrowButton, DownloadAppModal } from '@hover/shared-components';

const ReadyToSee: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <Box w="100%" py={1000} justifyContent="center" bg="yellow.100">
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Container maxW="1200px" overflow="hidden" centerContent>
        <Box
          flexDir={{ base: 'column', desktop: 'row' }}
          w="100%"
          alignItems="center"
          justifyContent="space-between"
        >
          <Container maxW={{ base: 'xl', desktop: 410 }} centerContent px={0}>
            <StaticImage
              placeholder="blurred"
              alt="ready to see possibilities"
              src="../../assets/images/how_does_it_work_ready_to_see.png"
            />
          </Container>
          <Box
            ml={{ base: 0, desktop: '60px' }}
            flexDir="column"
            alignItems={{ base: 'center', desktop: 'flex-start' }}
            pt={700}
            w="100%"
          >
            <Heading
              textAlign={{ base: 'center', desktop: 'start' }}
              size={{ base: 500, desktop: 700 }}
              color="red.500"
              marginBottom={500}
              as="h2"
            >
              Ready to see the possibilities?
            </Heading>
            <Heading
              as="p"
              size={{ base: 200, desktop: 500 }}
              fontWeight={{ base: 400, desktop: 400 }}
              style={{ marginBottom: 40 }}
            >
              Get a free 3D model of your home today.
            </Heading>

            <ArrowButton
              colorScheme="primary"
              w={{ base: '323px', tablet: '200px' }}
              onClick={toggleModal}
            >
              Get started
            </ArrowButton>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ReadyToSee;
